import React from "react"

import { ImageIcon } from "@editor/theme/editorIcons"

import { INSERT_IMAGE_COMMAND } from "@src/components/form/Editor/plugins/ImagesPlugin"
import { Button, Tooltip, apiClient, fileValidation, useAppContext } from "@dit/core-frontend"
import { API_ENDPOINTS } from "@src/constants"
import Dropzone from "react-dropzone"
import { Box, Text } from "@mos-cat/ds"

const ACCEPTFORMATS = ["image/jpeg", "image/jpg", "image/png"]

export const ImageUpload = ({
  editor,
  setIsDragging,
  isDragging,
  containerSize,
  buttonProps,
  isEditable,
}) => {
  const { showAlert } = useAppContext()
  const { appSettings } = useAppContext()
  const MAX_FILE_SIZE = appSettings?.sso_max_file_weight_mb?.value || 5
  const handleClick = (payload) => {
    editor.dispatchCommand(INSERT_IMAGE_COMMAND, payload)
  }

  const handleFileChange = async (file, rejected) => {
    setIsDragging(false)
    const formData = new FormData()
    formData.append("file", file[0])
    if (rejected.length) {
      const error = fileValidation(rejected[0], ACCEPTFORMATS, 1024 * 1024 * MAX_FILE_SIZE)
      if (error.startsWith("File is", 0)) {
        showAlert("Слишком большой размер файла")
      } else {
        showAlert(error)
      }

      return
    }
    try {
      const { data } = await apiClient.post(`${API_ENDPOINTS.file}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })

      if (data?.success && data?.data?.url) {
        handleClick({ src: data.data.url })
        showAlert("Загрузка прошла успешно", { type: "success" })
      }
    } catch (err) {
      let messageError = err?.data?.errors?.[0]?.message || err?.data?.detail
      if (!messageError && err.status === 413) {
        messageError = "Слишком большой размер файла"
      }
    }
  }
  return (
    <Dropzone
      maxSize={1024 * 1024 * MAX_FILE_SIZE}
      onDrop={(file, rejected) => handleFileChange(file, rejected)}
      validator={(file) => {
        return fileValidation({ file }, ACCEPTFORMATS, 1024 * 1024 * MAX_FILE_SIZE) || null
      }}
    >
      {({ getRootProps, getInputProps }) => (
        <>
          <Box
            position={isDragging ? "absolute" : "relative"}
            top={isDragging ? "0px" : "0px"}
            left="0px"
            height={isDragging ? `${containerSize.height}px` : ""}
            width={isDragging ? `${containerSize.width}px` : ""}
            borderWidth={isDragging ? "1px" : "0"}
            backgroundColor={isDragging ? "rgba(255, 255, 255, .8)" : ""}
            display="flex"
            alignItems="center"
            justifyContent={isDragging ? "center" : ""}
            {...getRootProps()}
          >
            {isDragging ? (
              <Text
                as={Box}
                fontSize="fs-32"
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                Перетащите файлы сюда
              </Text>
            ) : (
              <Tooltip content="Добавление изображения">
                <Button
                  style={{ cursor: "pointer" }}
                  {...buttonProps}
                  kind="borderless"
                  disabled={!isEditable}
                >
                  <ImageIcon />
                </Button>
              </Tooltip>
            )}
          </Box>

          {isDragging && (
            <Text style={{ cursor: "pointer" }}>
              <ImageIcon />
            </Text>
          )}

          <input {...getInputProps()} />
        </>
      )}
    </Dropzone>
  )
}
